<template>
  <b-row>

    <!-- Small -->


    <!-- Large -->
    <b-col cols="12">
      <b-form-group>
        <v-select v-if="categories != null" v-model="selected" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="name" :options="categories" class="select-size-lg" multiple />
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BFormGroup } from 'bootstrap-vue'
import vSelect from 'vue-select'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    vSelect,
  },
  props: {
    initialCategories: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      categories: null,
      selected: []
    }
  },
  created: async function () {
    await this.fetchCategories()
    this.selected = this.initialCategories
  },
  methods: {
    fetchCategories() {
      return axios
        .get('/lms/admin/course/category')
        .then((response) => {
          this.categories = response.data.data
        })
        .catch((error) => {
          console.error("Failed to fetch categories:", error)
        })
    }
  },
  watch: {
    selected(newVal) {
      this.$emit('selectionChanged', newVal)
    }
  }
}
</script>